import { createUseStyles } from 'react-jss';

import colors from "../../../utils/colors";







var styles = {
  cartItemContentWrapper: function cartItemContentWrapper(_ref) {var showMobileLayoutVersion = _ref.showMobileLayoutVersion;return {
      border: "1px solid ".concat(colors.neutral[400]),
      borderRadius: '1rem',
      backgroundColor: colors.neutral.white,
      padding: showMobileLayoutVersion ? '2.4rem 2rem' : '2.4rem 3.2rem',
      boxSizing: 'border-box',
      flex: '2 1 55%',
      overflowX: 'auto',
      position: 'relative'
    };},
  cardHeader: function cardHeader() {return {
      flexWrap: 'wrap',
      gap: '1rem'
    };},
  mobileCardHeader: {
    flexWrap: 'wrap',
    gap: '1rem',
    // Tag list
    '& div:last-child': {
      gap: '1rem',
      justifyContent: 'flex-start',
      // Tag item
      '& p': {
        marginRight: 0
      }
    }
  },
  productNameWrapper: function productNameWrapper() {return {
      flexWrap: 'wrap'
    };},
  mobileProductNameWrapper: function mobileProductNameWrapper() {return {
      flexWrap: 'wrap',

      '& h2': {
        maxWidth: '100%',
        fontSize: '1.6rem',
        margin: '0 0 1rem'
      },
      '& h2 svg': {
        display: 'none'
      },
      '& button': {
        marginLeft: 0,
        marginRight: 'auto'
      }
    };},
  cartItemContentWrapperChecked: function cartItemContentWrapperChecked() {return {
      padding: '2rem 1.6rem',
      borderLeft: "16px solid ".concat(colors.blue[600]),
      borderRight: "4px solid ".concat(colors.blue[600]),
      borderBottom: "4px solid ".concat(colors.blue[600]),
      borderTop: "4px solid ".concat(colors.blue[600])
    };},
  productContentWrapper: function productContentWrapper(_ref2) {var
      isPortfolioWithSeveralBc = _ref2.isPortfolioWithSeveralBc,
      isMultiProductPortfolio = _ref2.isMultiProductPortfolio,
      showMobileLayoutVersion = _ref2.showMobileLayoutVersion;return (
      {
        display: 'flex',
        flexDirection: 'row',
        borderTop:
        !isPortfolioWithSeveralBc &&
        !isMultiProductPortfolio && "0.1rem solid ".concat(
        colors.neutral[300]),
        paddingTop: (!isPortfolioWithSeveralBc || isMultiProductPortfolio) && '1.5rem',
        flexWrap: showMobileLayoutVersion ? 'wrap' : 'nowrap'
      });},
  productList: function productList(_ref3) {var
      isPortfolioWithSeveralBc = _ref3.isPortfolioWithSeveralBc,
      isMultiProductPortfolio = _ref3.isMultiProductPortfolio,
      showMobileLayoutVersion = _ref3.showMobileLayoutVersion;return (
      {
        borderTop:
        !isPortfolioWithSeveralBc && isMultiProductPortfolio && "0.1rem solid ".concat(colors.neutral[300]),
        paddingTop: isMultiProductPortfolio ? showMobileLayoutVersion ? '1.5rem' : '3rem' : 0
      });},
  innerProduct: function innerProduct(_ref4) {var isMultiProductPortfolio = _ref4.isMultiProductPortfolio;return {
      padding: isMultiProductPortfolio && '0 1rem 1.5rem',
      borderRadius: isMultiProductPortfolio && '0.6rem',
      border: isMultiProductPortfolio && "1px solid ".concat(colors.neutral[300]),
      '&:not(:last-child)': {
        marginBottom: isMultiProductPortfolio && '2rem'
      }
    };},
  disabledProduct: {
    backgroundColor: colors.neutral[100],
    opacity: '0.6',
    filter: 'grayscale(1)'
  },
  portfolioMainData: function portfolioMainData(_ref5) {var showMobileLayoutVersion = _ref5.showMobileLayoutVersion;return {
      flex: showMobileLayoutVersion ? '1 0 100%' : '1 0 35%',
      paddingRight: showMobileLayoutVersion ? 0 : '2rem',
      boxSizing: 'border-box'
    };},

  actionButton: function actionButton(_ref6) {var showMobileLayoutVersion = _ref6.showMobileLayoutVersion;return {
      textTransform: 'uppercase',
      paddingLeft: 0,
      maxWidth: showMobileLayoutVersion ? '100%' : '21rem',
      textAlign: 'left',
      '&:not(:last-child)': {
        marginBottom: '0.5rem'
      }
    };},
  // unique rates styles
  ratesList: {
    marginBottom: '1.6rem',
    borderBottom: "1px solid ".concat(colors.neutral[400]),
    '&  li:last-child': {
      paddingBottom: '1.8rem'
    },
    '& span:first-child': {
      fontSize: '1.4rem'
    }
  },
  ratesAdditionalStyle: {
    borderBottom: 'none'
  },

  mobileProductTiles: function mobileProductTiles() {return {
      padding: 0,
      paddingTop: '2rem',
      borderTop: "1px solid ".concat(colors.neutral[300]),
      marginTop: '1.6rem',
      '& li': {
        flexDirection: 'column',
        '& span': {
          padding: 0,
          width: 'auto'
        },
        '& span:first-child': {
          fontWeight: 700
        }
      }
    };},
  productTiles: function productTiles() {return {
      padding: 0,
      borderLeft: "1px solid ".concat(colors.neutral[300]),
      paddingLeft: '2rem'
    };},
  spinnerWrapper: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(255,255,255,0.8)'
  }
};

var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map